/**
 * Socket事件名定义
 */

/** 强制踢下线 */
export const EVENT_KICK = 'kick';

/** 当前用户的角色权限或所拥有的菜单信息被更新时 重新获取最新的权限菜单 */
export const EVENT_UPDATE_MENU = 'update_menu';
